<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="Senarai Bayaran Balik Pendidikan">
            <w-form ref="dform" @validate="search">

                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input v-model="cari.no_fail">No. Fail LBNK</w-input>
                    </div>
                    <div class="xs6 mr3">
                        <w-input v-model="cari.no_bayaran">No Bayaran</w-input>
                    </div>
                </w-flex>

                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input v-model="cari.nama_id">Id/Nama</w-input>
                    </div>
                    <div class="xs6 mr3">
                        <z-lookup
                            label="Status"
                            name="status"
                            :url="service_utiliti + 'lookup/lkp_bayaran_status'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.lkp_bayaran_status_id"
                        />
                    </div>
                </w-flex> <br>

                <w-flex>
                    <div class="xs6 mr3">
                        <w-input v-model="cari.dari"
                            required
                            label="Tarikh "
                            type="date"
                        />
                    </div>
                    <div class="xs6 mr3">
                       <w-input
                        type="date"
                        label="Hingga"
                        name="tarikh_hingga"
                        v-model="cari.hingga">
                       </w-input>
                    </div>
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button class="ml1" v-on:click="reset()" bg-color="warning">
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>

                    <w-button class="ml1" @click="$refs.dform.validate()" :loading="cari.loading">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>

            <br>
                <center v-if="cari.loading"><w-progress class="ma1" circle></w-progress></center>
            <z-table
                ref="tbluser"
                title="Paparan Rekod"
                :headers="table.headers"
                :items="table.items"
                :meta="table.meta"
                class=""
            >
                <!-- <template #button>
                    <w-button dark class="indigo-dark2--bg ml1" @click="newrecord()">
                        <w-icon class="mr1">fal fa-plus</w-icon> Tambah
                    </w-button>
                </template> -->

                <template #header-label="{ header, label, index }">
                    <template v-if="header.key == 'action'">
                        Tindakan
                    </template>
                </template>
                <template #item-cell.action="{ item, label, header, index }">
                    <w-flex class="flex justify-center">

                        <inertia-link :href="$route('pendidikan.show', item.sumber_model_id)">
                            <w-tooltip top>
                               <template #activator="{ on }">
                                 <w-icon v-on="on" >
                                   fal fa-file
                                 </w-icon>
                               </template>
                               Papar
                             </w-tooltip>
                        </inertia-link>

                    </w-flex>
                </template>
            </z-table>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
// import ZenOne from '@/Shared/ZenOne'
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_tunggakan + "pendidikan-bayaranbalik/bayaranbalik-senarai",
            reload: true,
            form_profil: {},
            crumbs:
            [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/ihasil" },
                { label: "Pendidikan", route: "/pendidikan" },
                { label: "Senarai ", route: "/pendidikan-bayar/bayaranbalik" },
            ],
            cari:
            {
                no_fail: "",
                no_bayaran: "",
                nama_id: '',
                profil_id: "",
                status: "",
                lkp_bayaran_status_id: "",
                dari: "",
                hingga: '',
            },
        };
    },
    methods: {
        search() {

            this.cari.loading = true
            this.$inertia.visit(
                window.route('pendidikan-bayaran-balik.index') +
                    '?no_fail=' +
                    this.cari.no_fail +
                    '&no_bayaran=' +
                    this.cari.no_bayaran +
                    '&nama_id=' +
                    this.cari.nama_id +
                    '&lkp_bayaran_status_id=' +
                    this.cari.lkp_bayaran_status_id +
                    '&dari=' +
                    this.cari.dari +
                    '&hingga=' +
                    this.cari.hingga,
                { preserveScroll: true }
            );


        },

        reset() {
            this.cari = {
                no_fail: "",
                no_bayaran: "",
                nama_id: "",
                lkp_bayaran_status_id: "",
                dari: "",
                hingga: "",
            };
            this.search();
        },

    },
    watch: {},
    mounted()
    {
        // override default setting
        // this.getData();
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.no_fail == "undefined") {
            this.cari.no_fail = "";
        }
        if (this.cari.no_bayaran == "undefined") {
            this.cari.no_bayaran = "";
        }
        if (this.cari.nama_id == "undefined") {
            this.cari.nama_id = "";
        }
        if (this.cari.profil_id == "undefined") {
            this.cari.profil_id = "";
        }

        if (this.cari.lkp_bayaran_status_id== "undefined") {
            this.cari.lkp_bayaran_status_id = "";
        }

        if (this.cari.dari== "undefined") {
            this.cari.dari = "";
        }

        if (this.cari.hingga== "undefined") {
            this.cari.hingga = "";
        }


    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
